import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';

function get(key, name) {
  return ContentStorage.get(key, name);
}

class ForgotPasswordModalContent {
  static get successMessage() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'SuccessMessage');
  }

  static get successMessageSubhead() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'SuccessMessageSubhead');
  }

  static get emailAddressProvidedLabel() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'EmailAddressProvidedLabel');
  }

  static get heading() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'Heading');
  }

  static get cancelButtonText() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'CancelButtonText');
  }

  static get sendEmailButtonText() {
      return get(ComponentKeys.FORGOT_PASSWORD, 'SendEmailButtonText');
  }

  static get closeButtonText() {
      return get(ComponentKeys.PASSWORD, 'CloseButtonText');
  }
}

export default ForgotPasswordModalContent;
